import { registerBlockType } from '@wordpress/blocks';

import metadata from '../block.json';
import Edit from './Edit';
import './editor.scss';
import { pdfIcon } from './utils/icons';

registerBlockType(metadata, {
	icon: pdfIcon,

	// Build in Functions
	edit: Edit,

	save: () => null
});